module.exports = __webpack_public_path__ + "r-v3/img/emoti-angry.1b313bf8.svg";